module.exports = __webpack_public_path__ + "img/favicon.84704055.png";